import React from 'react';
import { Helmet } from 'react-helmet-async';
import '../styles/ContactPage.css';

const ContactPage: React.FC = () => {
  // WhatsApp URL with phone number
  const whatsappUrl = "https://wa.me/+27617207853?text=";

  console.log('[DEBUG ContactPage] Rendering with SEO Helmet tags');

  return (
    <div className="contact-page">
      <Helmet>
        <title>Book Your Braai | Contact SpitFire Catering</title>
        <meta name="description" content="Book SpitFire Braai Catering for your next event. Get in touch for quotes, availability, and custom braai menus. Serving events across South Africa." />
        <meta property="og:title" content="Book Your Braai | Contact SpitFire Catering" />
        <meta property="og:description" content="Book SpitFire Braai Catering for your next event. Get in touch for quotes and availability." />
        <meta property="og:url" content="https://www.spitfirebraai.co.za/contact" />
        <link rel="canonical" href="https://www.spitfirebraai.co.za/contact" />
      </Helmet>
      <div className="container">
        <header className="contact-header">
          <h1>Book Your Braai</h1>
          <p>Let's bring the fire to your next event!</p>
        </header>

        <div className="contact-content">
          <div className="contact-form-container qr-code-container">
            <h2>WhatsApp Us</h2>

            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="qr-code-link"
            >
              <img
                src="/graphics/spitfire_qr.png"
                alt="WhatsApp QR Code"
                className="whatsapp-qr-code"
              />
              <p className="qr-code-caption">Scan or tap to chat</p>
            </a>
          </div>
          
          <div className="contact-info">
            <div className="info-card">
              <h3>Connect With Us</h3>
              <div className="social-links">
                <a
                  href="https://www.instagram.com/thespitfirebraai?igsh=bGszOHh1cmw0Y2dj"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                >
                  Instagram
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;